import { render } from "./SecondOrderReferenceItem.vue?vue&type=template&id=b785d3aa&scoped=true"
import script from "./SecondOrderReferenceItem.vue?vue&type=script&lang=js"
export * from "./SecondOrderReferenceItem.vue?vue&type=script&lang=js"

import "./SecondOrderReferenceItem.vue?vue&type=style&index=0&id=b785d3aa&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b785d3aa"]])

export default __exports__